import {
  SurfacePageBody,
  SurfacePageHeader,
  SurfacePageLayout,
} from '@/design-system';

export function AccessDeniedPanel({ resource = 'this surface' }: { resource?: string }) {
  return (
    <SurfacePageLayout width="full">
      <SurfacePageBody>
        <SurfacePageHeader
          title="Access denied"
          description={`Your role cannot open ${resource}. Switch to a manager persona or ask an administrator.`}
        />
      </SurfacePageBody>
    </SurfacePageLayout>
  );
}
